<template>
  <main-layout>
    <h1 class="title">Crea cliente</h1>
    <customer-form
      :submit-action="create"
      :fields="fields"
      redirect-route="customers.show"
    />
  </main-layout>
</template>

<script>
import { call } from "vuex-pathify"

import CustomerForm from "@/components/CustomerForm.vue"
import MainLayout from "@/layouts/Main.vue"
import { fields, showFields } from "./fields"

export default {
  components: {
    CustomerForm,
    MainLayout
  },
  data() {
    return {
      showFields,
      fields,
      loading: true
    }
  },
  methods: {
    create: call("customers/create")
  }
}
</script>

<style lang="sass" scoped>
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
